import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyType, CurrencyTypes } from '../customer-billing-price/currency-type';
import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

const CurrencyTypesMap = createMap(CurrencyTypes, 'Id');

export function fiCurrencyName(currencyId: CurrencyType, appText: AppTextService) {
    if (CurrencyTypesMap.hasOwnProperty(currencyId)) return appText.get(CurrencyTypesMap[currencyId].TextId);

    if (currencyId > 0) throw 'FI: Unknown currency "' + currencyId + '"';
}

@Pipe({
    name: 'fiCurrencyName',
    standalone: false,
})
export class CurrencyNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiCurrencyName(value, this.appText);
    }
}
